// extracted by mini-css-extract-plugin
module.exports = {"GamePlanTaskItem":"GamePlanTaskItem--2JV02","Icon":"Icon--3gGE5","Label":"Label--2jRhZ","GamePlan":"GamePlan--1nteS","Overdue":"Overdue--lCxDd","Caret":"Caret--1Mty4"};